// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AmazonSquareFilledSvg from "@ant-design/icons-svg/es/asn/AmazonSquareFilled";
import AntdIcon from '../components/AntdIcon';

var AmazonSquareFilled = function AmazonSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AmazonSquareFilledSvg
  }));
};

AmazonSquareFilled.displayName = 'AmazonSquareFilled';
export default React.forwardRef(AmazonSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AmazonSquareFilled.js
// module id = 561
// module chunks = 0